import { render, staticRenderFns } from "./VehiclesSidebar.vue?vue&type=template&id=6d0abeda&scoped=true&"
import script from "./VehiclesSidebar.vue?vue&type=script&lang=ts&"
export * from "./VehiclesSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./VehiclesSidebar.vue?vue&type=style&index=0&id=6d0abeda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0abeda",
  null
  
)

export default component.exports